import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.readonly)?[_vm._v(" "+_vm._s(_vm.number)+" ")]:_c(VTextField,_vm._b({ref:"field",attrs:{"rules":_vm.rules},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}},'v-text-field',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }